"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTextInputSchema = exports.default = void 0;
var DateTextInput_1 = require("./DateTextInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(DateTextInput_1).default; } });
Object.defineProperty(exports, "dateTextInputSchema", { enumerable: true, get: function () { return DateTextInput_1.dateTextInputSchema; } });
//# sourceMappingURL=index.js.map